(function() {

  var PRODUCT_HANDLE = 'purahome-filter-system';
  var DEFAULT_VARIANT_TITLE = '6 months (2 Filters)';

  function detectProductHandle() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.handle) {
        return window.ShopifyAnalytics.meta.product.handle;
      }
    } catch (e) {}
    try {
      if (window.meta && window.meta.product && window.meta.product.handle) {
        return window.meta.product.handle;
      }
    } catch (e) {}
    try {
      var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
      if (match) return match[1];
    } catch (e) {}
    return PRODUCT_HANDLE;
  }

  // ── Subscription config ──────────────────────────────────────────────────
  var SUBSCRIPTION_DISCOUNT_PCT = 15;
  var RECURRING_DISCOUNT_PCT    = 20;
  var SUBSCRIPTION_DEFAULT_ON   = false;

  var CARTRIDGE_HANDLE = 'purahome-new-cartidges';

  var SUBSCRIPTION_FAQS = [
    {
      q: 'How does it work?',
      a: 'Your starter pack ships today. After that, we automatically send replacement filters before your current ones run out — so you\'re never without clean water. On recurring orders you only ever pay for the replacement filters, never the whole system again.'
    },
    {
      q: 'What will I pay, and when?',
      a: 'You pay for your pack today with 15% off as a subscriber. After that you\'re only charged for replacement filters, at 20% off: {RECURRING_2F} every 6 months on the 6-month pack, or {RECURRING_4F} every 12 months on the 12-month and 18-month packs. Shipping is always free.'
    },
    {
      q: 'How often will filters arrive?',
      a: 'It matches your pack cadence. The 6-month pack delivers 2 replacement filters every 6 months. The 12-month and 18-month packs deliver 4 replacement filters every 12 months — the 18-month pack ships with 6 filters upfront (4 for your first year, plus 2 spares in case your water quality means you need to replace more frequently).'
    },
    {
      q: 'I chose the 18-month pack. What happens to my subscription after month 18?',
      a: 'After your initial 18-month supply, your subscription transitions to a 12-month refill cadence — 4 replacement filters every 12 months at 20% off. You can adjust frequency or cancel anytime from your customer portal.'
    },
    {
      q: 'Can I change or cancel?',
      a: 'Anytime — zero commitment. Adjust your delivery date, change frequency, skip an order, pause, or cancel from your customer portal. No emails or phone calls needed.'
    },
    {
      q: 'Do I keep the discount?',
      a: 'Yes. After your 15%-off first order, every recurring filter order is 20% off, for as long as your subscription stays active.'
    },
    {
      q: 'How do I manage my subscription?',
      a: 'After your first order you\'ll receive an email with a link to your customer portal, where you can update your shipping address, change your refill frequency, skip, pause, or cancel.'
    },
    {
      q: 'Anything else to know?',
      a: 'Discount codes can\'t be applied to subscription orders, and Afterpay isn\'t available on subscriptions — your 15% (first order) and 20% (recurring) subscriber savings are already built in.'
    }
  ];

  function getCurrencyRate() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
        return parseFloat(window.Shopify.currency.rate) || 1;
      }
    } catch (e) {}
    return 1;
  }

  function fetchCartridgePrices() {
    fetch('/products/' + CARTRIDGE_HANDLE + '.js')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(product) {
        var twoF = null, fourF = null;
        (product.variants || []).forEach(function(v) {
          var t = (v.title || '').toLowerCase();
          if (t.indexOf('2 filter') > -1) twoF = v.price / 100;
          if (t.indexOf('4 filter') > -1) fourF = v.price / 100;
        });
        state.cartridgePrices = { twoFilter: twoF, fourFilter: fourF };
        var modal = document.getElementById('ph2-modal');
        if (modal && modal.classList.contains('ph2-modal-open')) fillModalBody();
      })
      .catch(function(err) {
        console.error('[PH2] Could not load cartridge prices —', err);
        state.cartridgePrices = null;
      });
  }

  function getFaqs() {
    var currency = state.currency;
    var rate = getCurrencyRate();
    var recurMult = 1 - (RECURRING_DISCOUNT_PCT / 100);

    var twoTxt = 'the current filter price';
    var fourTxt = 'the current filter price';
    if (state.cartridgePrices) {
      if (state.cartridgePrices.twoFilter != null) {
        twoTxt = formatMoney(state.cartridgePrices.twoFilter * rate * recurMult, currency);
      }
      if (state.cartridgePrices.fourFilter != null) {
        fourTxt = formatMoney(state.cartridgePrices.fourFilter * rate * recurMult, currency);
      }
    }

    return SUBSCRIPTION_FAQS.map(function(faq) {
      return {
        q: faq.q,
        a: faq.a.replace('{RECURRING_2F}', twoTxt).replace('{RECURRING_4F}', fourTxt)
      };
    });
  }

  // ── Selling plan mapping ─────────────────────────────────────────────────
  // 18-month maps to the 12-month plan — initial order is 18 months of stock,
  // recurring refills run on the 12-month cadence.
  var SUBSCRIPTION_SELLING_PLANS = {
    '6 months (2 Filters)':   694262956348,  // 6-month plan
    '12 months (4 Filters)':  694263021884,  // 12-month plan
    '18 months (6 Filters)':  694263021884,  // 12-month plan (recurring after initial 18-month supply)
    '24 months (8 Filters)':  null,          // sold-out anchor — no subscription possible
  };

  function getSellingPlanIdFor(variant) {
    if (!variant) return null;
    return SUBSCRIPTION_SELLING_PLANS[variant.title] || null;
  }

  // ── Variant metadata ─────────────────────────────────────────────────────
  // Display order: 6 → 12 → 18 → 24 (sold out anchor)
  var VARIANT_ORDER = [
    '6 months (2 Filters)',
    '12 months (4 Filters)',
    '18 months (6 Filters)',
    '24 months (8 Filters)',
  ];

  var VARIANT_META = {
    '6 months (2 Filters)': {
      label: '6 Months Supply',
      sublabel: '(Filter System + 2 Filters)',
      badge: null,
      days: 182,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/2_18_c7ebb8f9-ed83-441f-ab16-0cb1954ac775.png?v=1775768153'
    },
    '12 months (4 Filters)': {
      label: '12 Months Supply',
      sublabel: '(Filter System + 4 Filters)',
      badge: 'Most Popular',
      days: 365,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/1_17_91bbc02e-2ca6-46ab-b5b4-d7fd867f6347.png?v=1775768153'
    },
    '18 months (6 Filters)': {
      label: '18 Months Supply',
      sublabel: '(Filter System + 6 Filters)',
      badge: 'Best Value',
      days: 548,
      image: ''
    },
    '24 months (8 Filters)': {
      label: '24 Months Supply',
      sublabel: '(Filter System + 8 Filters)',
      badge: null,
      days: 730,
      image: ''
    },
  };

  var CURRENCY_SYMBOLS = {
    'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'SGD': '$', 'HKD': '$',
    'GBP': '£', 'EUR': '€', 'JPY': '¥', 'CNY': '¥', 'INR': '₹',
    'CHF': 'Fr', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'ZAR': 'R',
    'MXN': '$', 'BRL': 'R$', 'AED': 'د.إ', 'THB': '฿', 'MYR': 'RM',
    'PHP': '₱', 'KRW': '₩', 'TRY': '₺',
  };

  var AFTERPAY_CURRENCIES = ['AUD', 'NZD', 'USD', 'CAD', 'GBP'];
  var AFTERPAY_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/after-pay.svg?v=1752685514';

  // ── Module state ─────────────────────────────────────────────────────────
  var state = {
    variants: [],
    currentVariantId: null,
    currency: 'AUD',
    subscriptionActive: SUBSCRIPTION_DEFAULT_ON,
    cartridgePrices: null
  };

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'AUD';
  }

  function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || '$';
  }

  function formatMoney(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch(e) { return '$' + amount.toFixed(2); }
  }

  function formatMoneyNoDecimal(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(amount);
    } catch(e) { return '$' + Math.round(amount); }
  }

  function formatPerDay(price, days, currency) {
    var symbol = getCurrencySymbol(currency);
    return symbol + (price / days).toFixed(2) + '/day';
  }

  function getEffectivePrice(basePrice) {
    if (state.subscriptionActive) {
      return basePrice * (1 - SUBSCRIPTION_DISCOUNT_PCT / 100);
    }
    return basePrice;
  }

  function getCurrentVariant() {
    for (var i = 0; i < state.variants.length; i++) {
      if (state.variants[i].id == state.currentVariantId) return state.variants[i];
    }
    return null;
  }

  // ── Price block (top) ────────────────────────────────────────────────────
  // Structure:
  //   [per-day hero]          ← large, dominant
  //   [compare strikethrough] [sale price] [SAVE badge]   ← smaller, secondary
  //   [afterpay strip]
  function buildPriceBlock() {
    var existing = document.getElementById('ph2-price-block');
    if (existing) existing.parentNode.removeChild(existing);

    var block = document.createElement('div');
    block.id = 'ph2-price-block';

    // Per-day hero line
    var perDayHero = document.createElement('div');
    perDayHero.id = 'ph2-perday-hero';
    perDayHero.style.cssText = 'font-size:1.4rem;font-weight:700;color:#2a5bd7;line-height:1.1;margin-bottom:4px;';
    block.appendChild(perDayHero);

    var perDaySub = document.createElement('div');
    perDaySub.id = 'ph2-perday-sub';
    perDaySub.style.cssText = 'font-size:0.8rem;color:#6b7280;margin-bottom:8px;';
    block.appendChild(perDaySub);

    // Secondary price row (compare + sale + badge) — smaller than before
    var priceRow = document.createElement('div');
    priceRow.id = 'ph2-price-row';
    priceRow.style.cssText = 'display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-bottom:4px;';

    var compareEl = document.createElement('span');
    compareEl.id = 'ph2-block-compare';
    compareEl.style.cssText = 'font-size:1.0rem;font-weight:600;text-decoration:line-through;color:#111827;';

    var saleEl = document.createElement('span');
    saleEl.id = 'ph2-block-sale';
    saleEl.style.cssText = 'font-size:1.0rem;font-weight:700;color:#2a5bd7;';

    var badgeEl = document.createElement('span');
    badgeEl.id = 'ph2-block-badge';
    badgeEl.style.cssText = 'font-size:0.7rem;font-weight:700;background:#01b778;color:#fff;padding:3px 10px;border-radius:20px;';

    priceRow.appendChild(compareEl);
    priceRow.appendChild(saleEl);
    priceRow.appendChild(badgeEl);
    block.appendChild(priceRow);

    // Afterpay strip
    var apStrip = document.createElement('div');
    apStrip.id = 'ph2-afterpay';
    apStrip.className = 'ph2-afterpay';

    var apText = document.createElement('span');
    apText.className = 'ph2-afterpay-text';
    apText.innerHTML = 'or 4 payments of <strong id="ph2-afterpay-amount"></strong> with';

    var apLogo = document.createElement('img');
    apLogo.src = AFTERPAY_LOGO_URL;
    apLogo.alt = 'Afterpay';
    apLogo.className = 'ph2-afterpay-logo';

    apStrip.appendChild(apText);
    apStrip.appendChild(apLogo);
    block.appendChild(apStrip);

    var picker = document.getElementById('ph2-picker');
    picker.parentNode.insertBefore(block, picker);
  }

  // ── Subscription checkbox ────────────────────────────────────────────────
  function buildSubscriptionCheckbox() {
    var existing = document.getElementById('ph2-subscription');
    if (existing) existing.parentNode.removeChild(existing);

    var box = document.createElement('div');
    box.id = 'ph2-subscription';
    box.className = 'ph2-subscription' + (state.subscriptionActive ? ' ph2-sub-active' : '');

    var checkbox = document.createElement('div');
    checkbox.className = 'ph2-sub-checkbox';
    checkbox.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><polyline points="5 12 10 17 19 7"></polyline></svg>';

    var text = document.createElement('div');
    text.className = 'ph2-sub-text';

    var title = document.createElement('div');
    title.className = 'ph2-sub-title';

    var titleText = document.createElement('span');
    titleText.textContent = 'Save ' + SUBSCRIPTION_DISCOUNT_PCT + '% with Automatic Refills!';
    title.appendChild(titleText);

    var infoBtn = document.createElement('button');
    infoBtn.type = 'button';
    infoBtn.className = 'ph2-info-icon';
    infoBtn.setAttribute('aria-label', 'How subscriptions work');
    infoBtn.innerHTML = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="#1e2764"/><circle cx="10" cy="5.6" r="1.25" fill="#fff"/><rect x="9" y="8.5" width="2" height="6.5" rx="1" fill="#fff"/></svg>';
    infoBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      openSubModal();
    });
    title.appendChild(infoBtn);

    var sub = document.createElement('div');
    sub.className = 'ph2-sub-sub';
    sub.textContent = 'Zero commitment, Cancel Anytime';

    text.appendChild(title);
    text.appendChild(sub);

    box.appendChild(checkbox);
    box.appendChild(text);

    box.addEventListener('click', function() {
      state.subscriptionActive = !state.subscriptionActive;
      box.classList.toggle('ph2-sub-active', state.subscriptionActive);
      applyPricing();
    });

    var picker = document.getElementById('ph2-picker');
    picker.parentNode.insertBefore(box, picker.nextSibling);
  }

  // ── Subscription modal ───────────────────────────────────────────────────
  function buildSubModal() {
    if (document.getElementById('ph2-modal')) return;

    var modal = document.createElement('div');
    modal.id = 'ph2-modal';
    modal.className = 'ph2-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'ph2-modal-title');

    var backdrop = document.createElement('div');
    backdrop.className = 'ph2-modal-backdrop';
    backdrop.addEventListener('click', closeSubModal);

    var boxEl = document.createElement('div');
    boxEl.className = 'ph2-modal-box';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ph2-modal-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 6L18 18M6 18L18 6" stroke="#1e2764" stroke-width="2.2" stroke-linecap="round"/></svg>';
    closeBtn.addEventListener('click', closeSubModal);

    var title = document.createElement('h3');
    title.id = 'ph2-modal-title';
    title.className = 'ph2-modal-title';
    title.textContent = 'How Automatic Refills Work';

    var bodyEl = document.createElement('div');
    bodyEl.className = 'ph2-modal-body';
    bodyEl.id = 'ph2-modal-body';

    boxEl.appendChild(closeBtn);
    boxEl.appendChild(title);
    boxEl.appendChild(bodyEl);
    modal.appendChild(backdrop);
    modal.appendChild(boxEl);
    document.body.appendChild(modal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('ph2-modal-open')) {
        closeSubModal();
      }
    });
  }

  function fillModalBody() {
    var bodyEl = document.getElementById('ph2-modal-body');
    if (!bodyEl) return;
    bodyEl.innerHTML = '';
    getFaqs().forEach(function(faq) {
      var item = document.createElement('div');
      item.className = 'ph2-faq';
      var q = document.createElement('div');
      q.className = 'ph2-faq-q';
      q.textContent = faq.q;
      var a = document.createElement('div');
      a.className = 'ph2-faq-a';
      a.textContent = faq.a;
      item.appendChild(q);
      item.appendChild(a);
      bodyEl.appendChild(item);
    });
  }

  function openSubModal() {
    buildSubModal();
    fillModalBody();
    var modal = document.getElementById('ph2-modal');
    if (modal) {
      modal.classList.add('ph2-modal-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSubModal() {
    var modal = document.getElementById('ph2-modal');
    if (modal) {
      modal.classList.remove('ph2-modal-open');
      document.body.style.overflow = '';
    }
  }

  // ── Pricing (single source of truth) ────────────────────────────────────
  function applyPricing() {
    var variant = getCurrentVariant();
    if (!variant) return;
    var currency = state.currency;
    var meta = VARIANT_META[variant.title] || { days: 365 };

    var effectivePrice = getEffectivePrice(variant.price);
    var comparePrice   = variant.compare_price;

    // Per-day hero
    var perDayHero = document.getElementById('ph2-perday-hero');
    var perDaySub  = document.getElementById('ph2-perday-sub');
    if (perDayHero) {
      perDayHero.textContent = formatPerDay(effectivePrice, meta.days, currency);
    }
    if (perDaySub) {
      var perDayAmount = getCurrencySymbol(currency) + (effectivePrice / meta.days).toFixed(2);
      perDaySub.textContent = 'That\'s ' + perDayAmount + ' a day for filtered water — less than bottled water';
    }

    // Secondary price row
    var compareEl = document.getElementById('ph2-block-compare');
    var saleEl    = document.getElementById('ph2-block-sale');
    var badgeEl   = document.getElementById('ph2-block-badge');

    if (saleEl) saleEl.textContent = formatMoneyNoDecimal(effectivePrice, currency);

    if (comparePrice && comparePrice > effectivePrice) {
      if (compareEl) {
        compareEl.textContent = formatMoneyNoDecimal(comparePrice, currency);
        compareEl.style.display = '';
      }
      if (badgeEl) {
        badgeEl.textContent = 'SAVE ' + formatMoneyNoDecimal(comparePrice - effectivePrice, currency);
        badgeEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (badgeEl)   badgeEl.style.display = 'none';
    }

    // Afterpay strip
    var apStrip  = document.getElementById('ph2-afterpay');
    var apAmount = document.getElementById('ph2-afterpay-amount');
    if (apStrip && apAmount) {
      var apSupported = AFTERPAY_CURRENCIES.indexOf(currency) !== -1;
      if (apSupported && !state.subscriptionActive) {
        apAmount.textContent = formatMoney(effectivePrice / 4, currency);
        apStrip.style.display = '';
      } else {
        apStrip.style.display = 'none';
      }
    }

    // Per-variant cards
    state.variants.forEach(function(v) {
      var card = document.querySelector('.ph2-card[data-variant-id="' + v.id + '"]');
      if (!card) return;

      var vMeta     = VARIANT_META[v.title] || { days: 365 };
      var effPrice  = getEffectivePrice(v.price);
      var compPrice = v.compare_price;

      var pctPill = card.querySelector('.ph2-pct-pill');
      if (!v.available) {
        card.classList.add('ph2-sold-out');
        card.classList.remove('ph2-selected');
        if (pctPill) pctPill.style.display = 'none';
      } else {
        card.classList.remove('ph2-sold-out');
        if (compPrice && compPrice > effPrice) {
          var pct = Math.round((1 - effPrice / compPrice) * 100);
          if (pctPill) {
            pctPill.textContent = pct + '% OFF';
            pctPill.style.display = '';
          }
        } else if (pctPill) {
          pctPill.style.display = 'none';
        }
      }

      var priceRow = card.querySelector('.ph2-price-row');
      if (priceRow) {
        priceRow.innerHTML = '';
        if (compPrice && compPrice > effPrice) {
          var compareSpan = document.createElement('span');
          compareSpan.className = 'ph2-compare';
          compareSpan.textContent = formatMoneyNoDecimal(compPrice, currency);
          priceRow.appendChild(compareSpan);
        }
        var currentSpan = document.createElement('span');
        currentSpan.className = 'ph2-current';
        currentSpan.textContent = formatMoneyNoDecimal(effPrice, currency);
        priceRow.appendChild(currentSpan);
      }

      var perDayEl = card.querySelector('.ph2-perday');
      if (perDayEl) {
        perDayEl.textContent = formatPerDay(effPrice, vMeta.days, currency);
      }
    });

    // ATC button price update (if price is embedded in button text)
    document.querySelectorAll('button[name="add"], .gp-btn-atc, [class*="add-to-cart"], [class*="atc"]').forEach(function(btn) {
      var text = btn.textContent || '';
      if (text.indexOf('$') > -1 || text.indexOf('£') > -1 || text.indexOf('€') > -1) {
        btn.innerHTML = btn.innerHTML
          .replace(/[£€¥₹₩₺฿][\d,]+\.?[\d]*/g, formatMoney(effectivePrice, currency))
          .replace(/\$[\d,]+\.?[\d]*/g, formatMoney(effectivePrice, currency));
      }
    });

    // URL + form inputs
    var sellingPlanId = getSellingPlanIdFor(variant);
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    if (state.subscriptionActive && sellingPlanId) {
      url.searchParams.set('selling_plan', sellingPlanId);
    } else {
      url.searchParams.delete('selling_plan');
    }
    window.history.replaceState({}, '', url.toString());

    document.querySelectorAll('input[name="id"]').forEach(function(inp) {
      if (inp.type !== 'radio') {
        inp.value = variant.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.querySelectorAll('[data-product-form], form[action*="/cart/add"]').forEach(function(form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp) {
        inp.value = variant.id;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var spInp = form.querySelector('input[name="selling_plan"]');
      if (state.subscriptionActive && sellingPlanId) {
        if (!spInp) {
          spInp = document.createElement('input');
          spInp.type = 'hidden';
          spInp.name = 'selling_plan';
          form.appendChild(spInp);
        }
        spInp.value = sellingPlanId;
        spInp.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (spInp) {
        spInp.parentNode.removeChild(spInp);
      }
    });
  }

  // ── Variant cards ────────────────────────────────────────────────────────
  function highlightCard(variantId, container) {
    container.querySelectorAll('.ph2-card').forEach(function(c) {
      c.classList.toggle('ph2-selected', c.getAttribute('data-variant-id') == variantId);
    });
  }

  function buildCards(variants, currency, container) {
    container.innerHTML = '';

    // Sort by VARIANT_ORDER
    variants.sort(function(a, b) {
      var ai = VARIANT_ORDER.indexOf(a.title);
      var bi = VARIANT_ORDER.indexOf(b.title);
      // Unknown titles go to end
      if (ai === -1) ai = 999;
      if (bi === -1) bi = 999;
      return ai - bi;
    });

    state.variants = variants;
    state.currency = currency;

    // Default selection: prefer DEFAULT_VARIANT_TITLE if available,
    // otherwise first available variant
    var defaultVariant = null;
    variants.forEach(function(v) {
      if (v.title === DEFAULT_VARIANT_TITLE && v.available) defaultVariant = v;
    });
    if (!defaultVariant) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { defaultVariant = variants[i]; break; }
      }
    }
    if (!defaultVariant) defaultVariant = variants[0];
    state.currentVariantId = defaultVariant.id;

    buildPriceBlock();

    variants.forEach(function(variant) {
      var meta = VARIANT_META[variant.title] || { label: variant.title, sublabel: '', badge: null, days: 365 };

      var card = document.createElement('div');
      card.className = 'ph2-card';
      card.setAttribute('data-variant-id', variant.id);
      card.setAttribute('data-variant-title', variant.title);

      if (meta.badge) {
        var badge = document.createElement('div');
        badge.className = 'ph2-badge';
        badge.textContent = meta.badge.toUpperCase();
        card.appendChild(badge);
      }

      var left = document.createElement('div');
      left.className = 'ph2-left';

      var titleRow = document.createElement('div');
      titleRow.className = 'ph2-title-row';

      var labelEl = document.createElement('span');
      labelEl.className = 'ph2-label';
      labelEl.textContent = meta.label;
      titleRow.appendChild(labelEl);

      var pctPill = document.createElement('span');
      pctPill.className = 'ph2-pct-pill';
      titleRow.appendChild(pctPill);

      left.appendChild(titleRow);

      var sublabelEl = document.createElement('div');
      sublabelEl.className = 'ph2-sublabel';
      sublabelEl.textContent = meta.sublabel;
      left.appendChild(sublabelEl);

      card.appendChild(left);

      var right = document.createElement('div');
      right.className = 'ph2-right';

      var priceRow = document.createElement('div');
      priceRow.className = 'ph2-price-row';
      right.appendChild(priceRow);

      var perDayEl = document.createElement('div');
      perDayEl.className = 'ph2-perday';
      right.appendChild(perDayEl);

      card.appendChild(right);

      var soldPill = document.createElement('span');
      soldPill.className = 'ph2-sold-pill';
      soldPill.textContent = 'SOLD OUT';
      card.appendChild(soldPill);

      card.addEventListener('click', function() {
        if (!variant.available) return;
        state.currentVariantId = variant.id;
        highlightCard(variant.id, container);
        applyPricing();
      });

      container.appendChild(card);
    });

    highlightCard(defaultVariant.id, container);
    buildSubscriptionCheckbox();
    applyPricing();
  }

  // ── Init ─────────────────────────────────────────────────────────────────
  function init() {
    var container = document.getElementById('ph2-cards');
    if (!container) return;

    var currency = getCurrency();
    var handle   = detectProductHandle();
    console.log('[PH2] Using product handle:', handle);

    fetchCartridgePrices();

    fetch('/products/' + handle + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(product) {
        var priceMap = {};
        if (window.variantData && Array.isArray(window.variantData)) {
          window.variantData.forEach(function(v) { priceMap[v.id] = v; });
        }
        var merged = product.variants.map(function(v) {
          var p = priceMap[v.id] || {};
          return {
            id: v.id,
            title: v.title,
            featured_image: v.featured_image,
            available: v.available !== false,
            price: p.price !== undefined ? p.price : v.price / 100,
            compare_price: p.compare_price !== undefined ? p.compare_price : (v.compare_at_price ? v.compare_at_price / 100 : null),
          };
        });
        buildCards(merged, currency, container);
      })
      .catch(function(err) {
        console.error('[PH2] Failed to fetch /products/' + handle + '.js —', err);
        if (window.variantData && Array.isArray(window.variantData) && window.variantData.length > 0) {
          var productVariants = (window.__st && window.__st.p && window.__st.p.variants) || null;
          var fallback = window.variantData.map(function(vd, idx) {
            var title = '';
            var featuredImage = null;
            if (productVariants) {
              productVariants.forEach(function(pv) {
                if (pv.id == vd.id) {
                  title = pv.title || pv.option1 || '';
                  featuredImage = pv.featured_image || null;
                }
              });
            }
            if (!title) title = VARIANT_ORDER[idx] || '';
            return {
              id: vd.id,
              title: title,
              featured_image: featuredImage,
              available: true,
              price: vd.price,
              compare_price: vd.compare_price
            };
          });
          buildCards(fallback, currency, container);
        } else {
          container.innerHTML = '<div style="color:#999;font-size:13px;padding:12px 0">Could not load options. Please refresh.</div>';
          console.error('[PH2] fetch error:', err);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();